import { supabase, checkSupabaseConnection } from '../services/supabase/client';

export const testConnection = async () => {
  try {
    console.log('🔍 Testing Supabase connection...');
    
    // 檢查環境變數
    const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
    const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
    
    if (!supabaseUrl || !supabaseKey) {
      console.error('❌ Missing Supabase environment variables');
      return false;
    }
    
    console.log('✅ Environment variables found');
    
    // 使用新的連接檢查函數
    const connectionStatus = await checkSupabaseConnection();
    
    if (!connectionStatus.isConnected) {
      if (connectionStatus.isPaused) {
        console.error('⚠️ Supabase 項目已暫停或無法連接');
        console.error('📝 請訪問 https://supabase.com/dashboard 恢復您的項目');
        console.error(`錯誤詳情: ${connectionStatus.error}`);
      } else {
        console.error('❌ Database connection failed:', connectionStatus.error);
      }
      return false;
    }
    
    console.log('✅ Database connection successful!');
    
    // 測試工匠查詢
    const { data: craftsmen, error: craftsmenError } = await supabase
      .from('craftsmen')
      .select('*')
      .limit(3);
    
    if (craftsmenError) {
      console.error('❌ Craftsmen query failed:', craftsmenError);
    } else {
      console.log('✅ Found', craftsmen?.length || 0, 'craftsmen');
    }
    
    return true;
  } catch (error: any) {
    if (error?.message?.includes('Failed to fetch')) {
      console.error('⚠️ 連接失敗: Supabase 項目可能已暫停');
      console.error('📝 解決方法:');
      console.error('   1. 訪問 https://supabase.com/dashboard');
      console.error('   2. 找到您的項目並點擊「恢復項目」');
      console.error('   3. 等待 1-2 分鐘後刷新頁面');
    } else {
      console.error('❌ Connection test failed:', error);
    }
    return false;
  }
};
